import { Redirect } from "wouter";

import { MUM_HUB_MEMBERSHIP_HREF } from "@/lib/mum-hub/membership";

/**
 * `/account/membership` is now a way back to `/account` (MAR-238).
 *
 * It was a page of its own (MAR-236). Her plan is a sheet over the account
 * page now, so the old URL sends her to the account page carrying the marker
 * that opens that sheet. The route stays registered rather than being deleted,
 * because it is in bookmarks and in anything that already links to it, and a
 * not-found page is a worse answer than the panel she was asking for.
 *
 * `replace` so the back button takes her wherever she came from rather than
 * back onto a URL that only ever redirects, which would be a loop she cannot
 * get out of by pressing back.
 *
 * There is no Mum Hub gate here, unlike the page it replaces. The redirect is
 * harmless to somebody the feature is not open to: she lands on `/account`,
 * which has no membership row and draws no sheet. Consulting the gate first
 * would mean holding her on a blank screen while it is read, to reach the same
 * place.
 *
 * Imported eagerly rather than lazily, because a redirect that arrives in its
 * own chunk shows the Suspense fallback before it can redirect.
 */
export default function MumHubMembershipRedirect() {
  return <Redirect to={MUM_HUB_MEMBERSHIP_HREF} replace />;
}
